/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GetRegion } from 'constants.js';
import { get } from 'lodash';
import { getContentListV1 } from 'utils/homologacion/homologacion';

class PosterTitle extends Component {
  render() {
    const { resource, metadata, type } = this.props;
    const region = GetRegion();
    const titleConfig = JSON.parse(
      get(
        metadata,
        'poster_title_configuration',
        '{"default": { "default": { "horizontal": false, "vertical": false } }}',
      ),
    );
    const titleConfigPerRegion = titleConfig[region] || titleConfig.default;
    const orientation =
      (type === 'Carrouselhorizontal' && 'horizontal') || 'vertical';

    const titleProviderConfig =
      titleConfigPerRegion[resource.proveedor_code] ||
      titleConfigPerRegion.default;

    const titleEnable = titleProviderConfig[orientation];

    if (
      titleEnable &&
      ((resource &&
        typeof resource.proveedor_code === 'string' &&
        (resource.proveedor_code.toLowerCase() !== 'amco' ||
          resource.showTitle) &&
        getContentListV1?.NoIsLive(resource)) ||
        resource.isRecording)
    ) {
      const titleClass = resource.showTitle ? 'carousel' : 'fox';

      return (
        <div className={`title-${titleClass}--div`}>
          <p className={`title-${titleClass}--p`}>{resource.title}</p>
        </div>
      );
    }
    return null;
  }
}

PosterTitle.propTypes = {
  resource: PropTypes.object,
  metadata: PropTypes.object,
  type: PropTypes.string,
};

const mapStateToProps = state => ({
  metadata: state.metadata,
});

export default connect(mapStateToProps)(PosterTitle);
